<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">
                            {{ $t(isEditContext ? 'Edit report' : 'Add new report') }}
                        </h6>
                        <button
                            type="button"
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="close"
                        >
                            <span aria-hidden="true">
                                <cancel-icon
                                    class="close-icon"
                                    style="height: 30px !important; width: 30px !important; color: #fff;"
                                />
                            </span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="comm-main-field">
                            <label class="key-div">{{ $t('Report Name') }} *</label>
                            <div class="value-div w-30 float-left m-0">
                                <div style="display: inline-flex" class="w-100">
                                    <div class="w-100">
                                        <div v-if="isEditContext" class="d-inline-flex">
                                            <span
                                                v-if="isEditContext && !isEditing('report_name') && localSelectedReport.report_name"
                                            >
                                                {{ localSelectedReport.report_name }}
                                            </span>
                                            <span
                                                v-else-if="isEditContext && !isEditing('report_name') && !localSelectedReport.report_name"
                                                class="empty-field-text-styles"
                                            >
                                            {{ $t('NONE')}}
                                            </span>

                                            <edit-icon
                                                v-show="!isEditing('report_name')"
                                                class="editIcon"
                                                @click.native="enterIntoEditMode('report_name')"
                                            />
                                        </div>

                                        <input
                                            v-if="isEditing('report_name') || !isEditContext"
                                            ref="report_name"
                                            v-model="queryMapper.report_name"
                                            type="text"
                                            min="0"
                                            :placeholder="$t('Enter report name')"
                                            class="rounded text-light comm-input-field-style align-input-field"
                                            style="height:42px"
                                        />
                                    </div>

                                    <div
                                        v-if="isEditing('report_name') && isEditContext"
                                        style="display: flex;align-items: center;"
                                    >
                                        <div class="d-flex">
                                            <save-icon @click.native="updateQueryBuildList('report_name')" />
                                            <cancel-icon @click.native="cancelEdit()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="comm-main-field">
                            <label class="key-div">{{ $t('Type') }} *</label>
                            <div class="value-div">
                                <div class="w-100" v-if="isEditContext && !isEditing('report_type')">
                                    <div class="d-inline-flex edit-icon-visibility">
                                        <span class="valueField">{{ localSelectedReport.report_type || 'NONE' }}</span>
                                        <!-- <edit-icon
                                            v-show="!isEditing('report_type')"
                                            class="editIcon"
                                            @click.native="enterIntoEditMode('report_type')"
                                        /> -->
                                    </div>
                                </div>

                                <div v-else class="comm-field-wrapper">
                                    <Multiselect
                                        ref="reportType"
                                        v-model="queryMapper.report_type"
                                        :options="queryTypesList"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :allow-empty="false"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        @input="handleReportTypeChange"
                                    >
                                        <div
                                            slot="option"
                                            slot-scope="scope"
                                            style="display:flex;max-height:12px;align-items:center;"
                                            class="checkbox-label"
                                        >
                                            <span style="margin-inline-start:12px;">
                                                {{ scope.option }}
                                            </span>
                                        </div>
                                    </Multiselect>

                                    <div
                                        v-if="isEditing('report_type') && isEditContext"
                                        style="display: flex;align-items: center;"
                                    >
                                        <div class="d-flex">
                                            <save-icon @click.native="updateQueryBuildList('report_type')" />
                                            <cancel-icon @click.native="cancelEdit()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-for="list in customReportsSelectionField">
                            <component
                                v-if="queryMapper.report_type === list.type && list.component"
                                :key="list.id"
                                :is="list.component"
                                :queryMapper="isEditContext && queryMapper ? queryMapper : null"
                                :pluginContext="getPluginContext()"
                                @plugin-field-change="handlePluginFieldUpdate"
                            />
                        </template>

                        <div class="comm-main-field" style="align-items:flex-start">
                            <label class="key-div">{{ $t('Query Parameters') }} *</label>
                            <div class="value-div">
                                <div class="comm-field-wrapper w-100" style="flex-direction:column">
                                    <div style="position:relative;margin-bottom:5px">
                                        <div class="filter-wrapper selected-filter" style="position:relative;width:95%">
                                            <div class="filter-label">{{ $t('Keyword') }}:</div>
                                            <input
                                                ref="query_keyword"
                                                v-model="queryKeyword"
                                                type="text"
                                                min="0"
                                                :placeholder="$t('Enter keyword')"
                                                class="rounded text-light comm-input-field-style align-input-field"
                                                style="width: 80%;"
                                            />
                                            <cancel-icon
                                                v-if="queryKeyword"
                                                style="position:absolute;inset-inline-end:1px;top:9px"
                                                @click="queryKeyword = ''"
                                            />
                                        </div>
                                    </div>
                                    <AdvancedSearch
                                        :key="queryMapper.report_type + (localSelectedReport._id || 'new')"
                                        ref="advanceSearchRef"
                                        compType="mainComp"
                                        :searchContext="getContext()"
                                        :searchContextPaylod="getSearchPayload"
                                        :appliedValues="isEditContext ? queryDetails : null"
                                        @advancedSearchData="advancedSearchData"
                                    />

                                    <div
                                        v-if="isEditContext"
                                        style="display: flex;align-items: center;height:35px"
                                    >
                                        <div class="d-flex">
                                            <button
                                                class="btn btn-outline-primary button-styles"
                                                style="float:inline-end"
                                                @click="updateQueryBuildList('query_params', true)"
                                            >
                                                {{ $t('Save') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="comm-main-field">
                            <label class="key-div">{{ $t('Columns required') }} *</label>
                            <div class="value-div">
                                <div class="w-100" v-if="isEditContext && !isEditing('columns_required')">
                                    <div class="d-inline-flex edit-icon-visibility" style="flex-wrap: wrap;">
                                        <div
                                            v-if="!localSelectedReport.columns_required || !localSelectedReport.columns_required.length"
                                            class="empty-field-text-styles"
                                        >
                                        {{ $t('NONE')}}
                                        </div>

                                        <div
                                            v-else
                                            v-for="cItem in localSelectedReport.columns_required"
                                            :key="cItem"
                                            class="search-in-filter-styles"
                                        >
                                            {{ cItem }}
                                        </div>

                                        <edit-icon
                                            v-show="!isEditing('columns_required')"
                                            class="editIcon"
                                            @click.native="enterIntoEditMode('columns_required')"
                                        />
                                    </div>
                                </div>

                                <div v-else class="comm-field-wrapper">
                                    <Multiselect
                                        ref="columnsRequiredDropdown"
                                        v-model="selectedColumnsRequiredArr"
                                        :options="columnsRequired"
                                        :placeholder="$t('Select columns')"
                                        :hideSelected="false"
                                        :close-on-select="true"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        :showNoOptions="false"
                                        :multiple="true"
                                        class="align-input-field-assets-search"
                                    >
                                        <span slot="noResult">{{ $t('No results.')}}</span>
                                    </Multiselect>

                                    <div
                                        v-if="isEditing('columns_required') && isEditContext"
                                        style="display: flex;align-items: center;"
                                    >
                                        <div class="d-flex">
                                            <save-icon @click.native="updateQueryBuildList('columns_required')" />
                                            <cancel-icon @click.native="cancelEdit()" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!isEditContext" class="modal-footer p-0 primary-btn-style">
                        <button
                            class="btn btn-outline-secondary button-styles"
                            style="float:inline-end"
                            @click.prevent="close"
                        >
                            {{ $t('Cancel') }}
                        </button>
                        <button
                            class="btn btn-outline-primary button-styles"
                            style="float:inline-end"
                            @click.prevent="clickToCreateNewQueryBuilder"
                        >
                            {{ $t('Save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Multiselect from "vue-multiselect";
import AdvancedSearch from "../core/AdvancedSearch.vue";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";

export default {
    name: "CustomReportModal",

    props: {
        isEditContext: {
            type: Boolean,
            default: false
        },
        selectedReport: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        "cancel-icon": cancelIcon,
        Multiselect,
        AdvancedSearch,
        "edit-icon": EditIcon,
        "save-icon": SaveIcon
    },

    data() {
        return {
            allTypesList: [],
            queryMapper: {},
            queryTypesList: [],
            editingKey: null,
            editedValue: "",
            previousEditingValue: null,
            allQueryParamtersList: [],
            labelOfLoadTypes: {},
            selectedFieldsInfo: [],
            columnsRequired: [],
            selectedColumnsRequiredArr: [],
            queryDetails: {},
            queryKeyword: "",
            externalFieldsList: [],
            payloadToLoadQueryParameters: null,
            localSelectedReport: {},
            isManualQueryParamsEdit: false
        };
    },

    computed: {
        getSearchPayload() {
            if (this.queryMapper.report_type === "Assets") return null;

            if (this.isManualQueryParamsEdit) {
                return {
                    name: "",
                    params: this.queryMapper.query_params || {}
                };
            }
            if (this.payloadToLoadQueryParameters && this.payloadToLoadQueryParameters.name) {
                return {
                    name: this.payloadToLoadQueryParameters.name,
                    params: this.payloadToLoadQueryParameters.params || {}
                };
            }

            const activePlugin = (this.customReportsSelectionField || []).find(
                (p) => p.type === this.queryMapper.report_type
            );

            if (activePlugin && activePlugin.searchContextName) {
                return {
                    name: activePlugin.searchContextName,
                    params: this.queryMapper.query_params || {}
                };
            }

            return {
                name: "",
                params: {}
            };
        },

        ...mapGetters("registry", {
            customReportsSelectionField: "getCustomReportsSelectionField"
        }),

        ...mapGetters("queryBuilder", {
            getQueryBuilderTypesGetter: "getQueryBuiderTypes",
            getQueryBuilderQueryParametersGetter: "getQueryBuiderQueryParamters",
            getColumnsRequiredInQueryBuilderReportGetter: "getColumnsRequiredInQueryBuilderReport"
        })
    },

    watch: {
        selectedReport: {
            immediate: true,
            deep: true,
            handler() {
                this.initializeComponentData();
            }
        },
        isEditContext: {
            immediate: true,
            handler() {
                this.initializeComponentData();
            }
        }
    },

    methods: {
        ...mapActions("queryBuilder", [
            "addNewQueryBuilder",
            "updateQueryBuilds",
            "getColumneRequiredInQueryBuilder"
        ]),
        ...mapMutations("registry", ["updateCustomReportsPlugins"]),

        cloneObject(data) {
            try {
                return JSON.parse(JSON.stringify(data));
            } catch (e) {
                return data;
            }
        },

        getSafeQueryTypes() {
            return Array.isArray(this.getQueryBuilderTypesGetter)
                ? this.getQueryBuilderTypesGetter
                : [];
        },

        getSafeColumnsRequired() {
            return Array.isArray(this.getColumnsRequiredInQueryBuilderReportGetter)
                ? this.getColumnsRequiredInQueryBuilderReportGetter
                : [];
        },

        initializeQueryParametersList() {
            const queryParamsList = this.getQueryBuilderQueryParametersGetter || {};
            const globalFilters = Array.isArray(queryParamsList.global_filters)
                ? queryParamsList.global_filters
                : [];
            const filters = Array.isArray(queryParamsList.filters)
                ? queryParamsList.filters
                : [];
            this.allQueryParamtersList = globalFilters.concat(filters);
        },

        getSelectedPluginByType(reportType = "") {
            const pluginList = Array.isArray(this.customReportsSelectionField)
                ? this.customReportsSelectionField
                : [];

            return (
                pluginList.find((plugin) => {
                    return plugin && plugin.type === reportType;
                }) || null
            );
        },

        getSelectedPlugin() {
            return this.getSelectedPluginByType(this.queryMapper.report_type);
        },

        getDefaultColumnsRequiredForType(reportType = "") {
            const selectedPlugin = this.getSelectedPluginByType(reportType);

            if (selectedPlugin && Array.isArray(selectedPlugin.defaultColumnsRequired)) {
                return [...selectedPlugin.defaultColumnsRequired];
            }

            return ["Slug Name", "Description"];
        },

        shouldClearColumnsRequiredForType(reportType = "") {
            const selectedPlugin = this.getSelectedPluginByType(reportType);

            if (
                selectedPlugin &&
                Object.prototype.hasOwnProperty.call(selectedPlugin, "clearColumnsRequiredOnInit")
            ) {
                return !!selectedPlugin.clearColumnsRequiredOnInit;
            }

            return false;
        },

        shouldClearColumnsRequiredOnContextChange(reportType = "") {
            const selectedPlugin = this.getSelectedPluginByType(reportType);

            if (
                selectedPlugin &&
                Object.prototype.hasOwnProperty.call(selectedPlugin, "clearColumnsRequiredOnContextChange")
            ) {
                return !!selectedPlugin.clearColumnsRequiredOnContextChange;
            }

            return false;
        },

        getPluginContext() {
            return {
                isEditContext: this.isEditContext,
                selectedReport: this.localSelectedReport,
                queryMapper: this.queryMapper
            };
        },

        initializeComponentData() {
            const safeSelectedReport =
                this.selectedReport && typeof this.selectedReport === "object"
                    ? JSON.parse(JSON.stringify(this.selectedReport))
                    : {};

            this.localSelectedReport = safeSelectedReport;

            this.queryTypesList = this.getSafeQueryTypes();
            this.columnsRequired = this.getSafeColumnsRequired();
            this.initializeQueryParametersList();

            this.queryMapper = {};
            this.queryDetails = {};
            this.queryKeyword = "";
            this.payloadToLoadQueryParameters = null;
            this.selectedColumnsRequiredArr = [];

            if (this.isEditContext) {
                this.queryMapper.report_name = safeSelectedReport.report_name || "";
                this.queryMapper.report_type = safeSelectedReport.report_type || "";
                this.queryMapper.query_params = this.cloneObject(
                    safeSelectedReport.query_params || {}
                );

                this.selectedColumnsRequiredArr = Array.isArray(
                    safeSelectedReport.columns_required
                )
                    ? [...safeSelectedReport.columns_required]
                    : [];

                if (
                    safeSelectedReport.query_params &&
                    typeof safeSelectedReport.query_params === "object"
                ) {
                    this.queryDetails = {
                        advanceFilter: JSON.stringify(safeSelectedReport.query_params)
                    };

                    if (safeSelectedReport.query_params.keyword) {
                        this.queryKeyword = safeSelectedReport.query_params.keyword;
                    }
                }

                const pluginList = Array.isArray(this.customReportsSelectionField)
                    ? this.customReportsSelectionField
                    : [];

                pluginList.forEach((plugin) => {
                    if (
                        plugin &&
                        plugin.fieldKey &&
                        Object.prototype.hasOwnProperty.call(safeSelectedReport, plugin.fieldKey)
                    ) {
                        this.$set(
                            this.queryMapper,
                            plugin.fieldKey,
                            this.cloneObject(safeSelectedReport[plugin.fieldKey])
                        );
                    }
                });

                const pluginSearchPayload = this.getGenericSearchPayloadFromReport(
                    safeSelectedReport,
                    pluginList
                );

                if (pluginSearchPayload) {
                    this.payloadToLoadQueryParameters = pluginSearchPayload;
                } else if (
                    safeSelectedReport.query_params &&
                    typeof safeSelectedReport.query_params === "object"
                ) {
                    this.payloadToLoadQueryParameters = {
                        params: {
                            ...safeSelectedReport.query_params
                        }
                    };
                }

                Object.keys(safeSelectedReport).forEach((key) => {
                    if (!Object.prototype.hasOwnProperty.call(this.queryMapper, key)) {
                        this.$set(this.queryMapper, key, this.cloneObject(safeSelectedReport[key]));
                    }
                });
            } else {
                const defaultType = this.queryTypesList.length ? this.queryTypesList[0] : "";

                this.queryMapper.report_name = "";
                this.queryMapper.report_type = defaultType;
                this.queryMapper.query_params = {};

                if (this.shouldClearColumnsRequiredForType(defaultType)) {
                    this.selectedColumnsRequiredArr = [];
                } else {
                    this.selectedColumnsRequiredArr =
                        this.getDefaultColumnsRequiredForType(defaultType);
                }
            }

            if (this.queryMapper.report_type) {
                this.loadColumnsByReportType();
            }
        },

        getGenericSearchPayloadFromReport(report, pluginList = []) {
            if (!report || typeof report !== "object") return null;

            for (let i = 0; i < pluginList.length; i++) {
                const plugin = pluginList[i];

                if (!plugin || !plugin.fieldKey) continue;

                const pluginValue = report[plugin.fieldKey];

                if (!pluginValue || typeof pluginValue !== "object") continue;

                if (
                    pluginValue.searchPayload &&
                    typeof pluginValue.searchPayload === "object"
                ) {
                    const payload = {
                        ...(pluginValue.searchPayload.name
                            ? { name: pluginValue.searchPayload.name }
                            : {}),
                        params:
                            pluginValue.searchPayload.params &&
                            typeof pluginValue.searchPayload.params === "object"
                                ? this.cloneObject(pluginValue.searchPayload.params)
                                : {}
                    };

                    return payload;
                }

                if (
                    pluginValue.query_params &&
                    typeof pluginValue.query_params === "object"
                ) {
                    return {
                        ...(pluginValue.name ? { name: pluginValue.name } : {}),
                        params: this.cloneObject(pluginValue.query_params)
                    };
                }
            }

            return null;
        },

        close() {
            this.$emit("closeModal", true);
        },

        isEditing(keyName) {
            return keyName === this.editingKey;
        },

        advancedSearchData(data) {
            const safeData = data && typeof data === "object" ? this.cloneObject(data) : {};
            
            this.queryDetails = { advanceFilter: JSON.stringify(safeData) };
            
            this.$set(this.queryMapper, "query_params", safeData);
            this.isManualQueryParamsEdit = true;
        },

        enterIntoEditMode(keyName) {
            this.editingKey = keyName;

            if (keyName === "columns_required") {
                this.previousEditingValue = Array.isArray(this.selectedColumnsRequiredArr)
                    ? [...this.selectedColumnsRequiredArr]
                    : [];
                this.selectedColumnsRequiredArr = Array.isArray(this.localSelectedReport.columns_required)
                    ? [...this.localSelectedReport.columns_required]
                    : [];
            } else if (keyName === "query_params") {
                this.previousEditingValue = this.cloneObject(this.queryMapper.query_params || {});
            } else {
                this.previousEditingValue = this.cloneObject(this.queryMapper[keyName]);
                this.$set(
                    this.queryMapper,
                    keyName,
                    this.cloneObject(this.localSelectedReport[keyName]) || ""
                );
            }
        },

        cancelEdit() {
            if (this.editingKey === "columns_required") {
                this.selectedColumnsRequiredArr = Array.isArray(this.previousEditingValue)
                    ? [...this.previousEditingValue]
                    : (
                        Array.isArray(this.localSelectedReport.columns_required)
                            ? [...this.localSelectedReport.columns_required]
                            : []
                    );
            } else if (this.editingKey === "query_params") {
                this.$set(
                    this.queryMapper,
                    "query_params",
                    this.cloneObject(this.previousEditingValue || this.localSelectedReport.query_params || {})
                );
            } else if (this.editingKey) {
                this.$set(
                    this.queryMapper,
                    this.editingKey,
                    this.cloneObject(this.localSelectedReport[this.editingKey]) || ""
                );
            }

            this.editingKey = null;
            this.editedValue = "";
            this.previousEditingValue = null;
        },

        getCompleteAdvancedSearchData() {
            const ref = this.$refs.advanceSearchRef;
            if (ref && ref.completeFormData && typeof ref.completeFormData === "object") {
                return this.cloneObject(ref.completeFormData);
            }
            return this.cloneObject(this.queryMapper.query_params || {});
        },

        buildFinalQueryParams() {
            const advancedSearch = this.$refs.advanceSearchRef;
            const uiFilters = this.getCompleteAdvancedSearchData();
            const filters = advancedSearch ? advancedSearch.filtersList || [] : [];
            const globalFilters = advancedSearch ? advancedSearch.globalFilters || [] : [];

            // Keep report context, but never restore old editable filter values.
            const contextParams = this.cloneObject(
                this.payloadToLoadQueryParameters?.params || {}
            );
            ["fields", "keyword", "search_in", "search_as"].forEach((key) => {
                delete contextParams[key];
            });
            filters.concat(globalFilters).forEach((filter) => {
                if (filter.filter_type !== "field") delete contextParams[filter.key];
            });

            // Global selections can be populated without updating completeFormData.
            if (advancedSearch && typeof advancedSearch.fetchGlobalFiltersSearchData === "function") {
                delete uiFilters.search_in;
                delete uiFilters.search_as;
                globalFilters.forEach((filter) => {
                    if (["created_on", "mime_type"].includes(filter.key)) {
                        delete uiFilters[filter.key];
                    }
                });
                Object.assign(uiFilters, this.cloneObject(advancedSearch.fetchGlobalFiltersSearchData()));
            }

            const finalQueryParams = { ...contextParams, ...uiFilters };
            delete finalQueryParams.keyword;
            if (this.queryKeyword?.trim()) {
                finalQueryParams.keyword = this.queryKeyword.trim();
            }

            return finalQueryParams;
        },

        hasValidQueryParams(queryParams) {
            if (!queryParams || typeof queryParams !== "object") return false;

            if (queryParams.keyword && queryParams.keyword.trim() !== "") return true;

            const rootKeys = Object.keys(queryParams).filter(k => k !== 'fields' && k !== 'keyword');
            if (rootKeys.length > 0) return true;

            if (queryParams.fields && typeof queryParams.fields === 'object') {
                if (Object.keys(queryParams.fields).length > 0) return true;
            }

            return false;
        },

        validateForm(isEdit = false, key = null) {
            if (!isEdit || key === "report_name") {
                if (!this.queryMapper.report_name || !this.queryMapper.report_name.trim()) {
                    this.$toast && this.$toast.error(this.$t("Please add valid report name"));
                    if (this.$refs.report_name) this.$refs.report_name.focus();
                    return false;
                }
            }

            if (!isEdit || key === "report_type") {
                if (!this.queryMapper.report_type || !String(this.queryMapper.report_type).trim()) {
                    this.$toast && this.$toast.error(this.$t("Please add valid report type"));
                    if (this.$refs.reportType && this.$refs.reportType.$el) {
                        this.$refs.reportType.$el.focus();
                    }
                    return false;
                }
            }

            if (!isEdit || key === "query_params") {
                const queryParams = this.buildFinalQueryParams();
                if (!this.hasValidQueryParams(queryParams)) {
                    this.$toast && this.$toast.error(this.$t("Please add query parameters"));
                    return false;
                }
            }

            if (!isEdit || key === "columns_required") {
                if (!Array.isArray(this.selectedColumnsRequiredArr) || !this.selectedColumnsRequiredArr.length) {
                    this.$toast && this.$toast.error(this.$t("Please add required columns"));
                    if (this.$refs.columnsRequiredDropdown && this.$refs.columnsRequiredDropdown.$el) {
                        this.$refs.columnsRequiredDropdown.$el.focus();
                    }
                    return false;
                }
            }

            return true;
        },

        async clickToCreateNewQueryBuilder() {
            if (!this.validateForm(false)) return;

            const finalQueryParams = this.buildFinalQueryParams();

            const payload = {
                report_name: this.queryMapper.report_name,
                report_type: this.queryMapper.report_type,
                query_params: finalQueryParams,
                columns_required: [...this.selectedColumnsRequiredArr]
            };

            const pluginList = this.customReportsSelectionField || [];
            pluginList.forEach((plugin) => {
                if (plugin.fieldKey && this.queryMapper[plugin.fieldKey]) {
                    payload[plugin.fieldKey] = this.queryMapper[plugin.fieldKey];
                }
            });

            try {
                const data = await this.addNewQueryBuilder(payload);
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message || "Saved");
                    this.close();
                }
            } catch (error) {
                this.$toast.error(this.$t("Error saving report"));
            }
        },

        addSelectedLoadTypePath() {
            const newUuid = Utils.getUUID();
            this.$set(this.labelOfLoadTypes, newUuid, "");
            this.selectedFieldsInfo.push({
                row_type: Constants.loadEmpty,
                type: "",
                field_id: "",
                uuid: newUuid,
                label: "",
                action: "",
                value: ""
            });
        },

        async updateQueryBuildList(key) {
            if (!this.validateForm(true, key)) return;

            const payload = {
                report_id: this.localSelectedReport._id,
                params: {}
            };

            if (key === "columns_required") {
                payload.params[key] = [...this.selectedColumnsRequiredArr];
            } else if (key === "query_params") {
                payload.params[key] = this.buildFinalQueryParams();
            } else {
                    payload.params[key] = this.cloneObject(this.queryMapper[key]);
                }

            try {
                const data = await this.updateQueryBuilds(payload);
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    if (data.message) this.$toast.success(data.message);

                    Object.keys(payload.params).forEach((paramKey) => {
                        this.$set(this.localSelectedReport, paramKey, this.cloneObject(payload.params[paramKey]));
                    });

                    if (payload.params.query_params) {
                        this.$set(this.queryMapper, "query_params", this.cloneObject(payload.params.query_params));
                        this.queryDetails = {
                            advanceFilter: JSON.stringify(payload.params.query_params)
                        };
                    }

                    this.editingKey = null;
                    this.editedValue = "";
                    this.previousEditingValue = null;
                } else if (data.message) {
                    this.$toast.error(data.message);
                }
            } catch (error) {
                this.$toast && this.$toast.error(this.$t("Failed to update report"));
            }
        },

        async handlePluginFieldUpdate(pluginData) {
            if (!pluginData || !pluginData.key) return;

            const oldPluginValue = this.cloneObject(this.queryMapper[pluginData.key] || null);
            const oldQueryParams = this.cloneObject(this.queryMapper.query_params || {});
            const newPluginValue = this.cloneObject(pluginData.value || null);

            if (JSON.stringify(oldPluginValue) === JSON.stringify(newPluginValue)) {
                return;
            }

            this.$set(this.queryMapper, pluginData.key, newPluginValue);

            let shouldReloadColumns = false;

            if (pluginData.searchPayload && pluginData.searchPayload.name) {
                const mergedParams = {
                    ...oldQueryParams,
                    ...(pluginData.searchPayload.params || {})
                };

                if (JSON.stringify(oldQueryParams) !== JSON.stringify(mergedParams)) {
                    this.$set(this.queryMapper, "query_params", mergedParams);

                    this.queryDetails = {
                        advanceFilter: JSON.stringify(mergedParams)
                    };

                    this.payloadToLoadQueryParameters = {
                        name: pluginData.searchPayload.name,
                        params: mergedParams
                    };

                    shouldReloadColumns = true;
                }
            }

            if (shouldReloadColumns) {
                await this.loadColumnsByReportType();
            }
        },

        async loadCustomReportsPlugins() {
            const pluginList = Array.isArray(this.customReportsSelectionField)
                ? this.customReportsSelectionField
                : [];

            for (let i = 0; i < pluginList.length; i++) {
                const plugin = pluginList[i];
                if (!plugin || !plugin.id) continue;

                if (
                    !Object.prototype.hasOwnProperty.call(plugin, "component") &&
                    plugin.pluginBundle &&
                    plugin.componentLoadedEventName
                ) {
                    try {
                        const compInfo = await Utils.loadPluginBundles(
                            [plugin.pluginBundle.js],
                            plugin.componentLoadedEventName
                        );

                        if (compInfo && Array.isArray(compInfo) && compInfo.length) {
                            if (plugin.pluginBundle.css) {
                                Utils.loadCssBundle(plugin.pluginBundle.css);
                            }

                            try {
                                const ev = new Event("register-routes");
                                if (Object.prototype.hasOwnProperty.call(compInfo[0], "pluginStore")) {
                                    ev.pluginStore = compInfo[0].pluginStore;
                                }

                                if (
                                    typeof parent !== "undefined" &&
                                    parent.document &&
                                    parent.document.body
                                ) {
                                    parent.document.body.dispatchEvent(ev);
                                }
                            } catch (e) {console.log("Error",e)}

                            if (
                                compInfo[0] &&
                                compInfo[0].components &&
                                compInfo[0].components.entry
                            ) {
                                this.updateCustomReportsPlugins({
                                    id: plugin.id,
                                    data: {
                                        component: compInfo[0].components.entry
                                    },
                                    type: plugin.type
                                });
                            }
                        }
                    } catch (e) {console.log(this.$t("Error"),e)}
                }
            }
        },

        async loadColumnsByReportType() {
            const reportType = this.queryMapper.report_type;
            if (!reportType) return;

            const payload = {
                params: {
                    type: reportType
                }
            };

            if (this.queryMapper.query_params && this.queryMapper.query_params.scope) {
                payload.params.scope = this.queryMapper.query_params.scope;
            }

            try {
                const data = await this.getColumneRequiredInQueryBuilder(payload);

                if (Utils.isAcceptedStatusCode(data.statusCode) && Array.isArray(data.column_names)) {
                    this.columnsRequired = [...data.column_names];

                    if (Array.isArray(this.selectedColumnsRequiredArr) && this.selectedColumnsRequiredArr.length) {
                        this.selectedColumnsRequiredArr = this.selectedColumnsRequiredArr.filter((item) =>
                            this.columnsRequired.includes(item)
                        );
                    }

                    if (
                        !this.isEditContext &&
                        (!Array.isArray(this.selectedColumnsRequiredArr) || !this.selectedColumnsRequiredArr.length)
                    ) {
                        if (this.shouldClearColumnsRequiredForType(reportType)) {
                            this.selectedColumnsRequiredArr = [];
                        } else {
                            const defaultColumns = this.getDefaultColumnsRequiredForType(reportType);
                            this.selectedColumnsRequiredArr = defaultColumns.filter((item) =>
                                this.columnsRequired.includes(item)
                            );
                        }
                    }
                } else if (data.message) {
                    this.columnsRequired = [];
                    this.selectedColumnsRequiredArr = [];
                    this.$toast.error(data.message);
                } else {
                    this.columnsRequired = [];
                    this.selectedColumnsRequiredArr = [];
                }
            } catch (error) {
                this.columnsRequired = [];
                this.selectedColumnsRequiredArr = [];
            }
        },

        async handleReportTypeChange() {
            const reportType = this.queryMapper.report_type;
            if (!reportType) return;

            this.payloadToLoadQueryParameters = null;
            this.$set(this.queryMapper, "query_params", {});
            this.queryDetails = {};
            this.queryKeyword = "";

            const pluginList = this.customReportsSelectionField || [];
            pluginList.forEach((plugin) => {
                if (plugin.fieldKey && this.queryMapper[plugin.fieldKey]) {
                    this.$delete(this.queryMapper, plugin.fieldKey);
                }
            });

            if (this.shouldClearColumnsRequiredForType(reportType)) {
                this.selectedColumnsRequiredArr = [];
            } else {
                this.selectedColumnsRequiredArr = this.getDefaultColumnsRequiredForType(reportType);
            }

            await this.loadColumnsByReportType();
            this.isManualQueryParamsEdit = false
        },

        getContext() {
            return "query-builder-in-reports";
        }
    },

    async mounted() {
        await this.loadCustomReportsPlugins();
    }
};
</script>

<style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;

    .comm-input-field-style{
        background: $primary-background!important;
        width: 99%;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
    }
    
    .modal-dialog {
        max-width: 600px;
        width: 600px;
        height: 90%;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: 300px;
            user-select: text !important; 
            cursor:text;
            display: inline-flex;
            flex-direction: column;
            padding: 10px !important;
            overflow:auto;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 5%;
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-inline-end: -4px;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:14px !important;
        height:100%;
    }

    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        .modal-title{
            color:$text-color;
        }
    }

    .modal-footer{
        padding: 5px 0px;
    }

    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }

    ul{
        list-style-type: none;
    }

    .primary-btn-style{
        text-align: end;
        button{
            height: 38px;
            font-size:14px;
            width: inherit;
        }
        .text-light:hover{
            text-decoration: underline;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .nav-item{
        color: $dull-text-color !important;
    }

    .inactive:hover{
        color:$text-color !important;
    }

    .active{
        background: $primary-background !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
    }

    .top-nav-bar{
        text-align: center;
        background: $primary-background;
    }

    ::-webkit-scrollbar {
        width: 8px;
        height:8px;
    }

    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background !important;
    }

    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background !important;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: $bg-color-on-hover !important;
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }

    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }

    .add-border{
        border: $border-color;
    }

    .minMaxTextarea{
        min-height: 38px;
    }

    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start: 0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }

    .dull-the-text{
        color: $dull-text-color;
    }

    ::placeholder {
        color: $dull-text-color !important;
    }

    .primary-btn-style button{
        height: 38px;
        width: 70px;
        font-size: 14px;
    }

    ul,.placeholder-file-name{
        list-style-type: none;
        padding: 0px;
        border: 1px solid #384445;
        border-radius: 10px;
        background: #202729 !important;
        margin: 10px 5px;
        padding: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        margin-top: 0px;
        li{
            display:inline-flex;
            width: 97%;
            padding:2px;
            .key-style{
                color:$dull-text-color;
                width:17%;
                text-align: end;
            }
            .value-style{
                color: #b6b6b6;
                width: 80%;
                text-align: start;
                margin-inline-start: 11px;
                word-break: break-all;
            }
        }
    }

    .editIcon {
        margin-inline-start: 9px;
        visibility: hidden;
    }

    .comm-main-field:hover .editIcon{
        visibility: visible;
    }

    .comm-main-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        cursor: pointer;
        margin:5px;
        .key-div{
            width:25% !important;
            text-align: start;
            margin-top: 4px;
        }

        .value-div{
            width:100%;
            .comm-field-wrapper{
                width:100%;
                display: flex;
            }
        }
    } 
    
    .add-screens-styles{
        display: inline-flex;
        height: 40px;
        border: 1px solid $add-button-border-color;
        border-radius: 5px;
        width: 100%;
        justify-content: center;
        line-height: 36px;
        color:$add-button-text-color;
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
    }

    .search-in-filter-styles{
        padding: 2px 8px;
        margin-inline-end: 5px;
        margin-bottom:5px;
        background-color: #1a1e21 !important;
        border: 1px solid #4a4a4a;
        border-radius: 5px;
        font-size: 14px;
    }

    ::v-deep{
        .dropdown-list {
            position: absolute !important;
        }    
        
        .align-input-field-assets-search{
            .multiselect__tags{
                height: auto !important;
            }
        }

        .comm-field-wrapper{
            .multiselect__tags{
                padding-top:6px;
                min-height:42px !important;
            }
        }

        .comm-field-wrapper{
            .advanced-search-wrapper{
                .multiselect__tags{
                    padding-top:unset !important;
                    min-height: 30px !important;                    
                }
                .mx-datepicker{
                    top: 3px !important;
                }
                .selected-filters-wrapper{
                    overflow: unset;
                }
            }
        }

        .filter-wrapper, .selected-filter{
            margin-inline-start:0px !important;
            margin-inline-end:5px !important;
            min-height: 38px !important;
            height: auto !important;
        }

        .multiselect{
            width:100% !important;
            margin: 3px 0px;
        }

        .multiselect__content-wrapper{
            display:none;
        }

        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }

        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }

        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }

        .multiselect__content {
            background: $secondary-background-color !important;
        }

        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }

        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }

        .multiselect__tag-icon{
            color:$text-color;
        }

        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }

        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }

        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }

        .multiselect__tags{
            padding: 4px 40px 0 8px;
        }

        .multiselect__placeholder {
            padding-top: 0px !important;
            margin-bottom:0px;
        }

        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            height: auto;
        }

        .multiselect__single{
            padding-top:3px !important;
        }

        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }

        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute !important;
            display: flex;
            background: $text-color;
            width: 100% !important;
            max-height: 240px !important;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }

        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }

        .multiselect--above .multiselect__content-wrapper{
            background:$secondary-background-color !important;
        }

        .multiselect__tags {
            background: $primary-background !important;
            height: auto;
        }
    }

    .selectedFilterRow{
        display:flex;
        align-items: center;
        .main-field{
            width: 40%;
            padding-bottom: 10px;
        }
    }

    .key-div {
        text-align: end;
        color: $dull-text-color;
    }
</style>